if (!window.__shScriptsCargado) {
  window.__shScriptsCargado = true;

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initContadores();
    initGaleriaProducto();
    initVariantesProducto();
    initFaq();
  });
}

function initReveals() {
  var els = document.querySelectorAll('.sh-reveal, .sh-reveal-stagger');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('sh-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sh-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('[data-sh-contador]');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el = entry.target;
        var fin = parseFloat(el.getAttribute('data-sh-contador')) || 0;
        var sufijo = el.getAttribute('data-sh-sufijo') || '';
        if (reduce) {
          el.textContent = fin + sufijo;
          return;
        }
        var duracion = 1400;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / duracion, 1);
          var valor = Math.round(fin * (1 - Math.pow(1 - progreso, 3)));
          el.textContent = valor + sufijo;
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-sh-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-sh-imagen-principal]');
  var miniaturas = galeria.querySelectorAll('[data-sh-miniatura]');
  if (!principal || !miniaturas.length) return;
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var nuevaSrc = mini.getAttribute('data-sh-src');
      var nuevoSrcset = mini.getAttribute('data-sh-srcset');
      if (nuevaSrc) principal.setAttribute('src', nuevaSrc);
      if (nuevoSrcset) principal.setAttribute('srcset', nuevoSrcset);
      miniaturas.forEach(function (m) { m.classList.remove('sh-miniatura-activa'); });
      mini.classList.add('sh-miniatura-activa');
    });
  });
}

function initVariantesProducto() {
  var wrap = document.querySelector('[data-sh-variantes]');
  if (!wrap) return;
  var datosEl = document.querySelector('[data-sh-variantes-json]');
  if (!datosEl) return;
  var variantes;
  try {
    variantes = JSON.parse(datosEl.textContent);
  } catch (e) {
    return;
  }
  var selects = wrap.querySelectorAll('select[data-sh-opcion]');
  var inputId = document.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-sh-precio]');
  var comparadoEl = document.querySelector('[data-sh-precio-comparado]');
  var botonComprar = document.querySelector('[data-sh-boton-comprar]');

  function variantePorSeleccion() {
    var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
  }

  function actualizar() {
    var variante = variantePorSeleccion();
    if (!variante) return;
    if (inputId) inputId.value = variante.id;
    if (precioEl) precioEl.textContent = variante.price_formatted;
    if (comparadoEl) {
      if (variante.compare_at_price_formatted) {
        comparadoEl.textContent = variante.compare_at_price_formatted;
        comparadoEl.style.display = '';
      } else {
        comparadoEl.style.display = 'none';
      }
    }
    if (botonComprar) {
      botonComprar.disabled = !variante.available;
      botonComprar.textContent = variante.available
        ? botonComprar.getAttribute('data-sh-texto-disponible')
        : botonComprar.getAttribute('data-sh-texto-agotado');
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
}

function initFaq() {
  var items = document.querySelectorAll('[data-sh-faq-item]');
  items.forEach(function (item) {
    var pregunta = item.querySelector('[data-sh-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('sh-faq-abierto');
      items.forEach(function (i) { i.classList.remove('sh-faq-abierto'); });
      if (!abierto) item.classList.add('sh-faq-abierto');
    });
  });
}
